const styles = () => ({
  page: {
    backgroundColor: '#FAF7F1',
    minHeight: '100vh',
    marginBottom: '70px',
  },
});

export default styles;
